import axios from 'axios'

export default {
  name: 'previewFeed',

  methods: {
    previewFeed (projectId, feedConfig) {
      this.isFeedPreviewLoading = true
      axios.post(process.env.VUE_APP_API_ENDPOINT + '/feed/preview/' + projectId, feedConfig)
        .then((response) => {
          if ((response.status === 201) || (response.status === 200)) {
            this.feedPreviewResponse = response.data
            this.isFeedPreviewLoading = false
          }
        })
        .catch(() => {
          //
        })
    }
  }
}
